import { toast } from "sonner";
import { updateCaseStudyVideo } from "./api";
import { useMutation } from "@tanstack/react-query";

function buildPayload(values) {
    const payload = {};

    Object.entries(values).forEach(([key, value]) => {
        if (
            ![].includes(key)
        ) {
            payload[key] = value;
        }
    });

    return payload;
}

export function useUpdateCasestudyVideo() {
    return useMutation({
        mutationFn: async ({ caseStudyId, values }) => {
            const payload = buildPayload(values);

            const response = await updateCaseStudyVideo({ caseStudyId, item: payload });
            return response;
        },
        onSuccess: () => {
            toast.success("Case Study video uploaded Successfully");
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
